import React from 'react';
import styled from 'styled-components';
import styles from '../../utility/styles';

const variants = {
    latest: {
        background: styles.colors.founders,
        color: styles.colors.background,
    },
    fsd: {
        background: styles.colors.purple,
        color: styles.colors.white,
    },
    rollingOut: {
        background: styles.colors.chargingGreen,
        color: styles.colors.background,
    },
    stable: {
        background: styles.colors.blue,
        color: styles.colors.background,
    },
}

const StyledBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 4px;
    font-family: ${styles.fonts.geist};
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    white-space: nowrap;
    background-color: ${({ variant }) => (variants[variant] || variants.stable).background};
    color: ${({ variant }) => (variants[variant] || variants.stable).color};
`

/**
 * @param {{ variant: 'latest'|'fsd'|'rollingOut'|'stable', children: any, style?: React.CSSProperties }} props
 */
export default function Badge({ variant = 'stable', children, style }) {
    return <StyledBadge {...{ variant, style }}>{children}</StyledBadge>
}
